import { FilterState } from "@Pages/Search/utils/formatFilterState";

const filtersReducer = (
  state: FilterState,
  {
    type,
    payload,
  }: {
    type: keyof FilterState | "reset" | "applyAll" | "leaseDuration";
    payload: any;
  },
): FilterState => {
  switch (type) {
    case "reset":
      return payload as FilterState;
    case "applyAll":
      return {
        ...payload,
      };
    case "leaseDuration":
      return {
        ...state,
        minLeaseDuration: "",
        maxLeaseDuration: "",
      };
    case "available":
    case "university":
    case "locality":
    case "moveInMonth":
    case "minLeaseDuration":
    case "maxLeaseDuration":
    case "budget":
    case "accommodationType":
    case "dualOccupancy":
    case "roomType":
    case "guarantor":
    case "sortKey":
    case "region_radius":
    case "housingType":
    case "amenities":
    case "billsIncluded":
      return {
        ...state,
        [type]: payload,
      };
    default:
      throw new Error(`unhandled action type in filters reducer: ${type}`);
  }
};

export default filtersReducer;
